import { render, staticRenderFns } from "./m_multiplechoicedouble.vue?vue&type=template&id=31ce4e21&scoped=true&"
import script from "./m_multiplechoicedouble.vue?vue&type=script&lang=js&"
export * from "./m_multiplechoicedouble.vue?vue&type=script&lang=js&"
import style0 from "./m_multiplechoicedouble.vue?vue&type=style&index=0&id=31ce4e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ce4e21",
  null
  
)

export default component.exports